import React, { useState } from "react";
import { TextField, Button, Typography, Box, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LabTestDialog from "./addTestDialog";
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";

export default function AddPackagePage({
  onClose,
  onSave,
  formData,
  setFormData,
  mode,
}) {
  const org=useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);
  const [testDialogOpen, setTestDialogOpen] = useState({
    open: false,
    data: null,
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    if (!formData.package_name)
      tempErrors.package_name = "Package Name is required";
    if (!formData.category) tempErrors.category = "Category is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleAddTest = (newTest) => {
    const updatedTests = [...formData.labPackageAndTestMapping];

    if (newTest._editIndex !== undefined) {
      const index = newTest._editIndex;
      const existingMapping = updatedTests[index];
      updatedTests[index] = {
        ...existingMapping,
        labTest: { ...newTest }, // Ensure we preserve ID and update fields
      };
    } else {
      updatedTests.push({ labTest: newTest });
    }

    setFormData({
      ...formData,
      labPackageAndTestMapping: updatedTests,
    });
    setTestDialogOpen({ open: false, data: null });
  };

  const handleEditTest = (index) => {
    const testToEdit = formData.labPackageAndTestMapping[index].labTest;
    setTestDialogOpen({
      open: true,
      data: { ...testToEdit, _editIndex: index },
    });
  };

  const handleSave = () => {
    if (validate()) {
      onSave();
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        {formData?.id ? "Edit Lab Package" : "Add Lab Package"}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Package Name"
            fullWidth
            value={formData?.package_name || ""}
            onChange={(e) =>
              setFormData({ ...formData, package_name:formatText(e.target.value) })
            }
            error={!!errors.package_name}
            helperText={errors.package_name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Category"
            fullWidth
            value={formData?.category || ""}
            onChange={(e) =>
              setFormData({ ...formData, category:formatText(e.target.value) })
            }
            error={!!errors.category}
            helperText={errors.category}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Footer"
            fullWidth
            multiline
            minRows={4}
            value={formData?.footer || ""}
            onChange={(e) =>
              setFormData({ ...formData, footer: e.target.value })
            }
          />
        </Grid>
      </Grid>

      <Box mt={4}>
        <Typography variant="h6">Lab Tests</Typography>
        <Button
          startIcon={<AddIcon />}
          onClick={() => setTestDialogOpen({ open: true, data: null })}
        >
          Add Test
        </Button>
        <ul>
          {(formData.labPackageAndTestMapping || []).map((map, i) => (
            <li key={i}>
              {map.labTest.testname} ({map.labTest.unit})
              <Button size="small" onClick={() => handleEditTest(i)}>
                Edit
              </Button>
            </li>
          ))}
        </ul>
      </Box>

      {/* <div className="d-flex gap-2 mt-4">
                <Button variant="contained" onClick={handleSave}>Save</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </div> */}

      {/* Buttons */}
      <div
        className="buttonsetconfirm"
        style={{
          marginTop: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "12px",
        }}
      >
        <Button
          variant="contained"
          color="error"
          onClick={onClose}
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          style={{ textTransform: "none" }}
        >
          Save
        </Button>
      </div>

      {testDialogOpen.open && (
        <LabTestDialog
          open={!!testDialogOpen.open}
          onClose={() => setTestDialogOpen({ open: false, data: null })}
          onSave={handleAddTest}
          editData={testDialogOpen.data}
        />
      )}
    </Box>
  );
}
